var ns;
ns.App.factory('ScreensService', function($http, API_ENDPOINT){
  return {
    // grid_server_call for grid serverPaging, serverFiltering, serverSorting
    getConfig: function(screen_id,grid_server_call){ 
      if (typeof grid_server_call == 'undefined') {
        grid_server_call = 0;
      }
      return $http.get('/screens/' + screen_id + "/config?grid_server_call="+grid_server_call);
      //return $http.get('/screens/' + screen_id + "/config", {cache: true});
    },
    getConfigTreeList: function(screen_id){
      return $http.get('/screens/' + screen_id + "/treelist");
      //return $http.get('/screens/' + screen_id + "/config", {cache: true});
    }
  };
});

